export default __webpack_public_path__ + "static/media/9608F74E-8952-4BFC-9813-89C78D590A78_1_102_o.662674bf.jpeg";